import { AxiosInstance } from 'axios';
import { genericFetch, genericPatch, genericPost } from './api';
import { Auth } from '../state/auth/types';
import { EventEntity } from '../state/events/types';
import { DataPayload } from '../state/types';

const ARTYC_EVENT_URL = '/artyc/events';
const companyEventsUrl = (auth: Auth | null) =>
  `/api/v1/company/${auth?.companyId}/events`;

const EventsApi = {
  getNewEventCount: async (
    axios: AxiosInstance,
    auth: Auth | null
  ): Promise<number> => {
    const response = await genericFetch<{ eventCount: number }>(
      axios,
      auth,
      `${ARTYC_EVENT_URL}/new-count`,
      `${companyEventsUrl(auth)}/new-count`
    );
    return response.eventCount;
  },
  dispositionEvent: async (
    axios: AxiosInstance,
    auth: Auth | null,
    eventId: string,
    payload: { disposition: string; reason: string; password: string }
  ) => {
    const url = `${companyEventsUrl(auth)}/event/${eventId}/disposition`;
    return genericPatch<{ success: string }>(axios, auth, url, url, payload);
  },
  markReviewed: async (
    axios: AxiosInstance,
    auth: Auth | null,
    eventIds: string[]
  ) => {
    return genericPatch<{ updated: number; skipped?: string[] }>(
      axios,
      auth,
      `${ARTYC_EVENT_URL}/review`,
      `${companyEventsUrl(auth)}/review`,
      { eventIds }
    );
  },
  downloadSegmentCsv: async (
    axios: AxiosInstance,
    auth: Auth | null,
    eventIds: string[]
  ) => {
    // TODO: type
    return genericPost<any>(
      axios,
      auth,
      `${ARTYC_EVENT_URL}/csvs`,
      `${companyEventsUrl(auth)}/csvs`,
      { eventIds },
      { responseType: 'blob' }
    );
  },
  getEventsForSegment: async (
    axios: AxiosInstance,
    auth: Auth | null,
    segmentId: string,
    eventType?: string | string[]
  ): Promise<EventEntity[]> => {
    const { entities } = await genericFetch<DataPayload<EventEntity>>(
      axios,
      auth,
      ARTYC_EVENT_URL,
      companyEventsUrl(auth),
      {
        filters: { segmentId, ...(eventType ? { eventType } : {}) },
        sortDirection: -1,
        paginate: 'false',
      }
    );

    return entities;
  },
  getEvent: async (
    axios: AxiosInstance,
    auth: Auth | null,
    eventId: string
  ): Promise<EventEntity> => {
    const response: EventEntity = await genericFetch(
      axios,
      auth,
      `${ARTYC_EVENT_URL}/event/${eventId}`,
      `${companyEventsUrl(auth)}/event/${eventId}`
    );
    return response;
  },
};

export default EventsApi;
